













































































































import { Vue, Component, Watch } from "vue-property-decorator";
import {
  isRoot,
  getCurrentUserId,
  getCurrentCompanyId,
  currentUserIsCompanyOwner
} from "@/plugins/roles";
import { Course as ICourse } from "@/api/models/course";
import { PracticePass as IPracticePass } from "@/api/models/practice-pass";
import { PracticePassList as IPracticePassList } from "@/api/models/practice-pass-list";
import SelectEntity from "@/components/form/SelectEntity.vue";
import practicePass, {
  PracticePassListParams
} from "@/getinfo-api/practice-pass";
import { uniqBy } from "lodash";
import PracticePassListItem from "@/components/practice/PracticePassListItem.vue";
import { CourseListenersList as ICourseListenersList } from "@/api/models/course-listeners-list";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import courseListeners, {
  CourseListenersListParams
} from "@/getinfo-api/course-listeners";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, CustomTable, SelectEntity, PracticePassListItem }
})
export default class PracticeList extends Vue {
  course!: ICourse | undefined;
  status!: string | undefined;
  listenerId!: string | undefined;
  limit: number = 30;
  offset: number = 0;
  practicePasses: Array<IPracticePass> = [];
  practicePassesCount: number = 0;
  showSpinner: boolean = false;
  showSpinnerForListener: boolean = false;
  listenerList!: Array<ICourseListener>;
  data() {
    return {
      course: undefined,
      status: undefined,
      listenerId: undefined,
      listenerList: undefined
    };
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  get userId() {
    return getCurrentUserId();
  }

  get root() {
    return isRoot();
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  showMore() {
    this.offset += this.limit;
    this.getPracticePasses(this.offset);
  }

  selectCourse(item: ICourse) {
    this.course = item;
    this.getPracticePasses();
  }

  getPracticePasses(offset: number = 0) {
    if (this.course?.id) {
      this.showSpinner = true;
      let params: PracticePassListParams = {
        id: this.course.id,
        offset: offset,
        //@ts-ignore
        statuses: this.status ? [this.status] : undefined,
        listenerId: this.listenerId ? this.listenerId : undefined,
        limit: this.limit
      };
      practicePass(params)
        .then((res: { data: IPracticePassList }) => {
          if (res.data.practices) {
            this.practicePassesCount = res.data.count;
            res.data.practices.forEach(element => {
              this.practicePasses.push(element);
            });
            this.practicePasses = uniqBy(this.practicePasses, "id");
          }
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  getLabel(option: ICourseListener) {
    let label;
    label = `${option.user.fullName}`;
    return label;
  }

  applyFilter() {
    this.practicePasses = [];
    this.offset = 0;
    this.practicePassesCount = 0;
    this.getPracticePasses(this.offset);
  }

  clearForm() {
    this.status = undefined;
    this.practicePasses = [];
    this.offset = 0;
    this.practicePassesCount = 0;
    this.listenerId = undefined;
    this.getPracticePasses();
  }

  @Watch("course")
  updateCourseListener() {
    this.listenerId = undefined;
    if (this.course) {
      this.showSpinnerForListener = true;
      let params: CourseListenersListParams = {
        id: this.course.id,
        limit: 300,
        offset: 0
      };

      courseListeners(params)
        .then((res: { data: ICourseListenersList }) => {
          this.listenerList = res.data.listeners;
        })
        .finally(() => {
          this.showSpinnerForListener = false;
        });
    }
  }

  @Watch("selectedCompany")
  updatePasses() {
    this.practicePasses = [];
    this.practicePassesCount = 0;
    this.offset = 0;
  }
}
